import { render } from "./SupportCart.vue?vue&type=template&id=4ecf3814"
import script from "./SupportCart.vue?vue&type=script&lang=js"
export * from "./SupportCart.vue?vue&type=script&lang=js"
script.render = render

export default script